import { addProp, body } from "@pnp/odata";
import { _User, User } from "../users/types.js";
import { Messages, MailboxSettings, MailFolders } from "./types.js";
import { graphPost } from "../operations.js";
addProp(_User, "messages", Messages);
addProp(_User, "mailboxSettings", MailboxSettings);
addProp(_User, "mailFolders", MailFolders);
_User.prototype.sendMail = function (message) {
    return graphPost(this.clone(User, "sendMail"), body(message));
};
//# sourceMappingURL=users.js.map